/* eslint-disable @typescript-eslint/semi */

// 'ts-ignore' works on the next line, so we need the next line
// @ts-ignore



// icons
import add from '../img/icons/add.icon.svg'; // @ts-ignore
import bordercolor from '../img/icons/bordercolor.icon.svg'; // @ts-ignore
import browserload from '../img/icons/browserload.icon.svg'; // @ts-ignore
import check from '../img/icons/check.icon.svg'; // @ts-ignore
import close from '../img/icons/close.icon.svg'; // @ts-ignore
import connect from '../img/icons/connect.icon.svg'; // @ts-ignore
import dimensions from '../img/icons/dimensions.icon.svg'; // @ts-ignore
import direction from '../img/icons/direction.icon.svg'; // @ts-ignore
import download from '../img/icons/download.icon.svg'; // @ts-ignore
import edit from '../img/icons/edit.icon.svg'; // @ts-ignore
import eye from '../img/icons/eye.icon.svg'; // @ts-ignore
import eyecrossed from '../img/icons/eyecrossed.icon.svg'; // @ts-ignore
import font from '../img/icons/font.icon.svg'; // @ts-ignore
import force from '../img/icons/force.icon.svg'; // @ts-ignore
import inputs from '../img/icons/inputs.icon.svg'; // @ts-ignore
import link from '../img/icons/link.icon.svg'; // @ts-ignore
import memcontent from '../img/icons/memcontent.icon.svg'; // @ts-ignore
import memlines from '../img/icons/memlines.icon.svg'; // @ts-ignore
import mouse from '../img/icons/mouse.icon.svg'; // @ts-ignore
import move from '../img/icons/move.icon.svg'; // @ts-ignore
import newcomponent from '../img/icons/newcomponent.icon.svg'; // @ts-ignore
import newwindow from '../img/icons/newwindow.icon.svg'; // @ts-ignore
import none from '../img/icons/none.icon.svg'; // @ts-ignore
import open from '../img/icons/open.icon.svg'; // @ts-ignore
import outputs from '../img/icons/outputs.icon.svg'; // @ts-ignore
import palette from '../img/icons/palette.icon.svg'; // @ts-ignore
import pause from '../img/icons/pause.icon.svg'; // @ts-ignore
import pen from '../img/icons/pen.icon.svg'; // @ts-ignore
import placement from '../img/icons/placement.icon.svg'; // @ts-ignore
import play from '../img/icons/play.icon.svg'; // @ts-ignore
import question from '../img/icons/question.icon.svg'; // @ts-ignore
import questioncircled from '../img/icons/questioncircled.icon.svg'; // @ts-ignore
import redo from '../img/icons/redo.icon.svg'; // @ts-ignore
import { default as ref, default as regroup } from '../img/icons/ref.icon.svg'; // @ts-ignore
import replace from '../img/icons/replace.icon.svg'; // @ts-ignore
import reset from '../img/icons/reset.icon.svg'; // @ts-ignore
import screenshot from '../img/icons/screenshot.icon.svg'; // @ts-ignore
import setinput from '../img/icons/setinput.icon.svg'; // @ts-ignore
import settings from '../img/icons/settings.icon.svg'; // @ts-ignore
import slanted from '../img/icons/slanted.icon.svg'; // @ts-ignore
import step from '../img/icons/step.icon.svg'; // @ts-ignore
import strokewidth from '../img/icons/strokewidth.icon.svg'; // @ts-ignore
import swap from '../img/icons/swap.icon.svg'; // @ts-ignore
import testcase from '../img/icons/testcase.icon.svg'; // @ts-ignore
import timer from '../img/icons/timer.icon.svg'; // @ts-ignore
import trash from '../img/icons/trash.icon.svg'; // @ts-ignore
import tutorial from '../img/icons/tutorial.icon.svg'; // @ts-ignore
import undo from '../img/icons/undo.icon.svg'; // @ts-ignore
import wirestyle from '../img/icons/wirestyle.icon.svg'; // @ts-ignore
import xray from '../img/icons/xray.icon.svg'; // @ts-ignore


// images
import ALU from '../img/ALU.svg'; // @ts-ignore
import Add3IfGeq5 from '../img/Add3IfGeq5.svg'; // @ts-ignore
import Adder from '../img/Adder.svg'; // @ts-ignore
import AdderArray from '../img/AdderArray.svg'; // @ts-ignore
import Bypass from '../img/Bypass.svg'; // @ts-ignore
import Clock from '../img/Clock.svg'; // @ts-ignore
import Comparator from '../img/Comparator.svg'; // @ts-ignore
import ControlledInverter from '../img/ControlledInverter.svg'; // @ts-ignore
import Counter from '../img/Counter.svg'; // @ts-ignore
import Decoder from '../img/Decoder.svg'; // @ts-ignore
import Decoder16Seg from '../img/Decoder16Seg.svg'; // @ts-ignore
import Decoder7Seg from '../img/Decoder7Seg.svg'; // @ts-ignore
import DecoderBCD from '../img/DecoderBCD.svg'; // @ts-ignore
import Demux from '../img/Demux.svg'; // @ts-ignore
import Display16Seg from '../img/Display16Seg.svg'; // @ts-ignore
import Display4 from '../img/Display4.svg'; // @ts-ignore
import Display7Seg from '../img/Display7Seg.svg'; // @ts-ignore
import Display8 from '../img/Display8.svg'; // @ts-ignore
import DisplayAscii from '../img/DisplayAscii.svg'; // @ts-ignore
import DisplayBar from '../img/DisplayBar.svg'; // @ts-ignore
import FlipflopD from '../img/FlipflopD.svg'; // @ts-ignore
import FlipflopJK from '../img/FlipflopJK.svg'; // @ts-ignore
import FlipflopT from '../img/FlipflopT.svg'; // @ts-ignore
import GateArray from '../img/GateArray.svg'; // @ts-ignore
import HalfAdder from '../img/HalfAdder.svg'; // @ts-ignore
import IncDec from '../img/IncDec.svg'; // @ts-ignore
import Input1 from '../img/Input1.svg'; // @ts-ignore
import Input4 from '../img/Input4.svg'; // @ts-ignore
import Input8 from '../img/Input8.svg'; // @ts-ignore
import Label from '../img/Label.svg'; // @ts-ignore
import LatchD from '../img/LatchD.svg'; // @ts-ignore
import LatchSR from '../img/LatchSR.svg'; // @ts-ignore
import Mux from '../img/Mux.svg'; // @ts-ignore
import Output1 from '../img/Output1.svg'; // @ts-ignore
import Output4 from '../img/Output4.svg'; // @ts-ignore
import Output8 from '../img/Output8.svg'; // @ts-ignore
import Passthrough1 from '../img/Passthrough1.svg'; // @ts-ignore
import PassthroughN from '../img/PassthroughN.svg'; // @ts-ignore
import Pixel from '../img/Pixel.svg'; // @ts-ignore
import RAM from '../img/RAM.svg'; // @ts-ignore
import ROM from '../img/ROM.svg'; // @ts-ignore
import Random from '../img/Random.svg'; // @ts-ignore
import Rectangle from '../img/Rectangle.svg'; // @ts-ignore
import Register from '../img/Register.svg'; // @ts-ignore
import ShiftDisplay from '../img/ShiftDisplay.svg'; // @ts-ignore
import ShiftRegister from '../img/ShiftRegister.svg'; // @ts-ignore
import TristateBufferArray from '../img/TristateBufferArray.svg'; // @ts-ignore
import and from '../img/and.svg'; // @ts-ignore
import and3 from '../img/and3.svg'; // @ts-ignore
import and4 from '../img/and4.svg'; // @ts-ignore
import buf from '../img/buf.svg'; // @ts-ignore
import imply from '../img/imply.svg'; // @ts-ignore
import nand from '../img/nand.svg'; // @ts-ignore
import nand3 from '../img/nand3.svg'; // @ts-ignore
import nand4 from '../img/nand4.svg'; // @ts-ignore
import nimply from '../img/nimply.svg'; // @ts-ignore
import nor from '../img/nor.svg'; // @ts-ignore
import nor3 from '../img/nor3.svg'; // @ts-ignore
import nor4 from '../img/nor4.svg'; // @ts-ignore
import not from '../img/not.svg'; // @ts-ignore
import or from '../img/or.svg'; // @ts-ignore
import or3 from '../img/or3.svg'; // @ts-ignore
import or4 from '../img/or4.svg'; // @ts-ignore
import tri from '../img/tri.svg'; // @ts-ignore
import txa from '../img/txa.svg'; // @ts-ignore
import xnor from '../img/xnor.svg'; // @ts-ignore
import xnor3 from '../img/xnor3.svg'; // @ts-ignore
import xnor4 from '../img/xnor4.svg'; // @ts-ignore
import xor from '../img/xor.svg'; // @ts-ignore
import xor3 from '../img/xor3.svg'; // @ts-ignore
import xor4 from '../img/xor4.svg'; // @ts-ignore

void 0 // dummy line to consume the last 'ts-ignore'

import { Modifier, applyModifierTo, raw } from './htmlgen'

const icons = {
    add,
    bordercolor,
    browserload,
    check,
    close,
    connect,
    dimensions,
    direction,
    download,
    edit,
    eye,
    eyecrossed,
    font,
    force,
    inputs,
    link,
    memcontent,
    memlines,
    mouse,
    move,
    newcomponent,
    newwindow,
    none,
    open,
    outputs,
    palette,
    pause,
    pen,
    placement,
    play,
    question,
    questioncircled,
    redo,
    ref,
    regroup,
    replace,
    reset,
    screenshot,
    setinput,
    settings,
    slanted,
    step,
    strokewidth,
    swap,
    testcase,
    timer,
    trash,
    tutorial,
    undo,
    wirestyle,
    xray,
}

const images = {
    Add3IfGeq5,
    Adder,
    AdderArray,
    ALU,
    Bypass,
    and,
    and3,
    and4,
    buf,
    Clock,
    Comparator,
    Counter,
    Decoder,
    Decoder7Seg,
    Decoder16Seg,
    DecoderBCD,
    Demux,
    FlipflopD,
    FlipflopJK,
    FlipflopT,
    GateArray,
    HalfAdder,
    IncDec,
    imply,
    Input1,
    Input4,
    Input8,
    Random,
    Rectangle,
    Label,
    LatchSR,
    LatchD,
    Mux,
    nand,
    nand3,
    nand4,
    nimply,
    nor,
    nor3,
    nor4,
    not,
    or,
    or3,
    or4,
    Output1,
    Output4,
    Output8,
    Display7Seg,
    Display16Seg,
    DisplayAscii,
    DisplayBar,
    Display4,
    Display8,
    ShiftDisplay,
    Passthrough1,
    PassthroughN,
    Pixel,
    RAM,
    ROM,
    Register,
    ShiftRegister,
    ControlledInverter,
    tri,
    TristateBufferArray,
    txa,
    xnor,
    xnor3,
    xnor4,
    xor,
    xor3,
    xor4,
}

export type IconName = keyof typeof icons
export function isIconName(name: string): name is IconName {
    return name in icons
}

export type ImageName = keyof typeof images
export function isImageName(name: string): name is ImageName {
    return name in images
}

export function makeImage(name: ImageName, width?: number, height?: number): HTMLElement {
    return makeSvgHolder("svgimg", name, raw(inlineSvgFor(images, name)), width, height)
}

export function makeIcon(name: IconName, width?: number, height?: number): HTMLElement {
    return makeSvgHolder("svgicon", name, raw(inlineSvgFor(icons, name)), width, height)
}

export function makeSvgHolder(className: string, iconName: string, content: Modifier, width?: number, height?: number): HTMLElement {
    const elem = document.createElement('i')
    elem.classList.add(className)
    elem.setAttribute('data-icon', iconName)
    if (width !== undefined) {
        elem.style.width = `${width}px`
    }
    if (height !== undefined) {
        elem.style.height = `${height}px`
    }
    applyModifierTo(elem, content)
    return elem
}

function inlineSvgFor<TImages extends Record<string, string>>(svgData: TImages, name: keyof TImages): string {
    return svgData[name]
}

export function inlineIconSvgFor(name: IconName): string {
    return inlineSvgFor(icons, name)
}

export function inlineImageSvgFor(name: ImageName): string {
    return inlineSvgFor(images, name)
}


